import React from 'react'
import { useNavigate } from 'react-router-dom'
import "./Community.css"

function Community() {
  const navigate = useNavigate();
  const scrollToImpact = () => {
    document.getElementById("community-impact")?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <>
            {/* Header Section */}
            <section className="community-banner bg-color">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-5 mb-5 mb-lg-0">
                            <img loading="lazy" decoding="async" 
                                src={require("../../app/assets/images/coummity-conversation.webp")}
                                alt="Rural Children" 
                                className="arch-img"
                            />
                        </div>
                        <div className="col-lg-7 ps-lg-5">
                            <div className='community-banner-txt-wraper'>
                            <h1 className="banner-heading text-black">Travel That Supports <span>Rural Futures</span></h1>
                            <p className="banner-sub-heading text-black">A community-run eco lodge near Jim Corbett.</p>
                            <p className="content">
                                Camp Hornbill is rooted in a vision where tourism supports both people and the planet. In partnership with the Kumaon Maati Foundation, we work towards local employment, youth engagement, cultural preservation, and sustainable tourism practices. Every stay directly contributes to strengthening the relationship between the forest, the community, and the future of the region.
                            </p>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

            <section className='section-padding' id="community-impact" style={{ scrollMarginTop: "140px" }}>
                <div className='container'>
                                                <div className="row g-3">
                                <div className="col-xxl-3 col-lg-4 col-md-6 col-12">
                                    <div className="stat-card">
                                        <h3>Community-led model</h3>
                                        <p>Owned and run by local villagers; 70% of the space preserved as forest</p>
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-lg-4 col-md-6 col-12">
                                    <div className="stat-card">
                                        <h3>Local livelihoods</h3>
                                        <p>Employment across hospitality, guiding, farming, and operations</p>
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-lg-4 col-md-6 col-12">
                                    <div className="stat-card">
                                        <h3>Youth & women empowerment</h3>
                                        <p>Skill-building in eco-guiding, crafts, and sustainable livelihoods</p>
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-lg-4 col-md-6 col-12">
                                    <div className="stat-card">
                                        <h3>Kumaon Maati Foundation</h3>
                                        <p>Community initiative supporting conservation, education, and rural development</p>
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-lg-4 col-md-6 col-12">
                                    <div className="stat-card">
                                        <h3>Cultural preservation</h3>
                                        <p>Local food, traditions, stories, and village life experiences</p>
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-lg-4 col-md-6 col-12">
                                    <div className="stat-card">
                                        <h3>Sustainable practices</h3>
                                        <p>Waste management, rainwater harvesting, and solar energy use</p>
                                    </div>
                                </div>
                                <div className="col-xxl-3 col-lg-4 col-md-6 col-12">
                                    <div className="stat-card">
                                        <h3>Real impact through travel</h3>
                                        <p>
                                            Every stay supports 30+ local livelihoods and helps preserve the land.
                                        </p>
                                    </div>
                                </div>
                            </div>
                </div>
            </section>
           

            {/* Foundation Section */}
            <section className="section-padding">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 foundation-img-wrapper mb-4 mb-lg-0">
                            <img loading="lazy" decoding="async" 
                                src={require("../../app/assets/images/kumon-mati.avif")} 
                                alt="Community Group" 
                                className="foundation-img"
                            />
                            <div className="partner-badge">
                                <img loading="lazy" decoding="async" src={require("../../app/assets/images/icons/partner.webp")} alt="Iamge" />
                                <span>Partnered with</span>
                                <strong>Kumaon Maati</strong>
                            </div>
                        </div>
                        <div className="col-lg-6 ps-lg-5">
                            <div className='mb-30'>
                            <span className="top-heading">Heritage & Sustainability</span>
                            <h2 className="kumaon-mati-text">Kumaon Maati <span>Foundation</span></h2>
                            <p className="content">
                                In 2022 we established this non-profit, now run by the community, to channel tourism funds into conservation and social projects. Money raised from stays helps plant trees, clean rivers, and run village schools.
                            </p>
                            </div>
                            <div className="d-flex gap-3">
                                <button className="primary_btn" onClick={() => navigate("/our-story")}>Learn More →</button>
                                <button className="outline_btn" onClick={scrollToImpact}>Foundation Impact</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* What makes us different Section */}
            <section className="section-padding bg-color">
                <div className="container">
                    <div className="heading-content-wraper">
                        <h2 className="heading text-center">What makes us <span>different?</span></h2>
                        <div className="diveder-bx"></div>
                        <p className="content text-center">
                            We are deeply committed to our responsibility towards society and the community, actively engaging in a variety of social initiatives. Our efforts focus on environmental conservation, promoting sustainable rural livelihoods, raising environmental awareness, empowering women, and much more.
                        </p>
                    </div>

                    <div className="row g-5">
                        <div className="col-md-6">
                            <img loading="lazy" decoding="async" src={require("../../app/assets/images/waste-mangement-img.webp")} alt="Waste Management" className="impact-img" />
                            <h4 className="heading">Our Commitment to Responsible Waste Management</h4>
                            <p className="content">
                                We believe in responsible consumption and proper waste disposal. To support this, we actively participate in initiatives led by Waste Warriors. Our team ensures proper waste segregation, categorizing it for efficient disposal by Waste Warriors. In addition to waste management, we are deeply involved in raising community awareness about responsible waste disposal. Through events and cleanup drives, we work to keep our surroundings clean and protect the environment.
                            </p>
                        </div>
                        <div className="col-md-6">
                            <img loading="lazy" decoding="async" src={require("../../app/assets/images/community-awareness.webp")} alt="Community Awareness" className="impact-img" />
                            <h4 className="heading">Community Awareness and Living in Harmony with Nature</h4>
                            <p className="content">
                                We are committed to raising awareness among youth, the local community, and other stakeholders about the importance of living in harmony with nature. Through hands-on experiences in the jungle ecosystem, we teach participants about the delicate balance of life in the wild. We believe it's crucial to spread the message that humans are not the sole inhabitants of this planet; we share it with a vast and interconnected ecosystem. By fostering this understanding, we aim to instill a deeper respect for nature and promote responsible stewardship at every level.
                            </p>
                        </div>
                                <div className="col-md-6">
                                    <img loading="lazy" decoding="async" src={require("../../app/assets/images/local-communities.jpeg")} alt="Empowerment" className="impact-img" />
                                    <h4 className="heading">Empowering Local Communities and Promoting Livelihoods</h4>
                                    <p className="content">
                                        As members of the same community, we believe in fostering local development. Our primary goal is to create sustainable livelihood opportunities for local people, and we've achieved this by employing team members from nearby villages. Today, our team is a balanced mix of both men and women from the community. We are strong advocates for skill development and partner with organizations like Udhyam to enhance local capacity. Additionally, we organize events for village women and collaborate with nonprofits to uplift livelihoods and promote women's empowerment in the region.
                                    </p>
                                </div>

                    </div>
                </div>
            </section>
    </>
  )
}

export default Community